var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 489,
    height: 76,
    viewBox: "0 0 489 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.9724 7.86948C59.9671 1.38444 49.9968 0 43.0832 0H0V75.1973H43.0832C60.6221 75.1973 79.3254 65.8705 79.3254 39.7846V34.8298C79.3254 23.0255 75.5411 13.9173 67.9724 7.86948ZM60.331 39.7846C60.331 53.7748 52.9079 60.8428 38.2072 60.8428H18.9217V13.7716H38.2072C52.9079 13.7716 60.331 20.8396 60.331 34.8298V39.7846Z",
    fill: "#1B1836"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.404 0H95.4092V75.1463H114.404V0Z",
    fill: "#1B1836"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.157 75.1973H185.65L162.362 48.7471L149.481 63.3931V75.1973H130.486V0H149.481V36.7243L181.72 0H205.227L174.152 35.4127L209.157 75.1973Z",
    fill: "#1B1836"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M273.854 0H243.652C232.154 0 219.127 0 219.127 16.0304V59.1669C219.127 75.1973 232.154 75.1973 243.652 75.1973H273.854C285.353 75.1973 298.452 75.1973 298.452 59.1669V16.0304C298.452 0 285.353 0 273.854 0ZM279.458 58.0739C279.458 60.7699 278.075 60.8428 274.8 60.8428H242.706C239.504 60.8428 238.049 60.7699 238.049 58.0739V17.1234C238.049 14.4274 239.504 14.3545 242.706 14.3545H274.8C278.075 14.3545 279.458 14.4274 279.458 17.1234V58.0739Z",
    fill: "#1B1836"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M393.862 43.1365V59.1669C393.862 75.1973 380.835 75.1973 369.263 75.1973H314.536V60.8428H370.282C373.484 60.8428 374.94 60.7699 374.94 58.0739V44.2294C374.94 41.5334 373.484 41.4605 370.282 41.4605H339.134C327.563 41.4605 314.536 41.4605 314.536 25.4301V16.0304C314.536 0 327.563 0 339.134 0H388.986V14.3545H338.115C334.913 14.3545 333.531 14.4274 333.531 17.1234V24.3371C333.531 27.0332 334.913 27.106 338.115 27.106H369.263C380.835 27.106 393.862 27.106 393.862 43.1365Z",
    fill: "#1B1836"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M488.324 0V14.3545H455.211V75.1973H436.29V14.3545H403.177V0H488.324Z",
    fill: "#1B1836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarLogo);
export default __webpack_public_path__ + "static/media/navbarLogo.1079f31acfcfe802c3203749a76d5712.svg";
export { ForwardRef as ReactComponent };